import React from 'react';
import { useTranslation } from 'react-i18next';
import CatalogManager from './CatalogManager';
import { Material } from '../../types/catalogs';

const MaterialsPage: React.FC = () => {
  const { t } = useTranslation();
  const columns = [
    { key: 'codigo', label: t('code') },
    { key: 'descripcion', label: t('description') },
  ];

  const formFields = [
    { name: 'codigo', label: t('code'), type: 'text' as const, required: true },
    { name: 'descripcion', label: t('description'), type: 'text' as const, required: true },
    { name: 'activo', label: t('active'), type: 'checkbox' as const },
  ];

  const createEmptyItem = () => ({
    codigo: '',
    descripcion: '',
    activo: true,
  });

  const validateItem = (item: any) => {
    if (!item.codigo?.trim()) return t('requiredCode');
    if (!item.descripcion?.trim()) return t('requiredDescription');
    return null;
  };

  return (
    <CatalogManager<Material>
      title={t('catalogMaterials')}
      apiEndpoint="materials"
      columns={columns}
      formFields={formFields}
      getItemId={(item) => item.id}
      getItemAttributes={(item) => item.attributes}
      createEmptyItem={createEmptyItem}
      validateItem={validateItem}
    />
  );
};

export default MaterialsPage;
